module.exports = __webpack_public_path__ + "img/V-Guard-Industries-Ltd.48a13f54.jpg";